/**
 * Created by xy on 2018/11/23.
 */
import React, {Component} from 'react';
import {NavBar, Toast,Modal} from 'antd-mobile';
import {nationalActivity} from '../../service/addLines';
import {connect} from 'react-redux';
import moment from 'moment';
import './style.less';
const activity = require('../../common/image/activity.png');
@connect(
    state => ({userInfo: state.userInfo})
)
 
export default class LineActivity extends Component {
    constructor(props) {
        super(props);
       
        this.state = {
            lineData: []
        };
    }
 
    componentDidMount() {
        this.lineListData();
    };
    
    lineListData(){
        Toast.loading("正在加载",0);
        let params={
            pageSize:100,
            pageNo:1,
        };
        nationalActivity(params)
            .then((res)=>{
                Toast.hide();
                if (res.data.code === '000000') {
                    this.setState({
                        lineData: res.data.data == '' ? [] : res.data.data.list,
                    });
                    console.log(this.state.lineData)
                }else if (res.data.code === '100003') {
                    Modal.alert('提示', '登录过期，是否要重新登录?', [
                        { text: '取消'},
                        { text: '确认', onPress: () =>  window.location.href  = 'https://api.cema99.com/app/author' },
                    ]);
                }
            }).catch(function (error) {
                Toast.hide();
                console.log(error);
            });
    };
     
     
  
   
    render() {
        return (
            <div className="LineActivity">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/>}
                >线路活动</NavBar>
                <div>
                    <img src={activity}/>
                </div>
                <div className="content">
                    {
                        this.state.lineData.map((res,index) =>(
                            <div className="lineItem" key={index}>
                                    <div className="itemLeft">
                                        <div><p>{res.startName}——{res.endName}</p><p>{moment(res.startTime).format('YYYY-MM-DD')} ~ {moment(res.endTime).format('YYYY-MM-DD')}</p></div>                           
                                    </div>
                                    <div className="itemLeft">
                                        <div className="colorGray">原价：￥<span>{res.origPrice}起 </span>&nbsp; <span>￥{res.currentPrice}</span><div className="redBackground">积分折扣{res.point}元</div></div>                           
                                    </div> 
                            </div>
                        ))
                    
                    }
                </div>
                <div className="borderFather">
                    <p></p>
                    <div className="explain">活动说明</div>
                </div>
                <div className="footerWord">
                    <p>1.上述展示的价格仅仅只是班次中某个座位的价格，不同座位价格有所不同，可使用积分折扣一致。</p>
                    <p>2.只有以上活动线路才支持使用积分折扣。</p>
                    <p>3.本次活动最终解释权归云南顺佳捷汽车租赁服务公司所有。</p>
                </div>
            </div>
        )
        
    }
}



// WEBPACK FOOTER //
// ./src/container/LineActivity/index.js